// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var cards = "BettingPageSkeleton-module--cards--dd103";
export var emphasis = "BettingPageSkeleton-module--emphasis--d5c08";
export var green = "#57d33b";
export var greenLink = "BettingPageSkeleton-module--green-link--21f06";
export var grey = "var(--tone-mid)";
export var notchGap = "32px";
export var orange = "#f8662b";
export var red = "#ff2741";
export var sgmButton = "BettingPageSkeleton-module--sgmButton--bfb23";
export var tab = "BettingPageSkeleton-module--tab--2bec9";
export var tabs = "BettingPageSkeleton-module--tabs--78215";
export var title = "BettingPageSkeleton-module--title--3be55";
export var titleFilter = "BettingPageSkeleton-module--titleFilter--30b27";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";